.root {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  border: 1px dashed var(--line);
  border-radius: 12px;
  background: var(--sunk);
}

.icon {
  flex-shrink: 0;
  color: var(--st-cancel);
}

.title {
  flex: 1;
  min-width: 0;
  font-size: 12.5px;
  color: var(--ink-2);
}
